var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _linearGradient10, _path9, _linearGradient11, _path10, _linearGradient12, _path11, _linearGradient13, _path12, _linearGradient14, _path13, _linearGradient15, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -7747.177,
    y1: -1223.085,
    x2: -7746.177,
    y2: -1223.085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: 57.221,
    y1: 28.968,
    x2: 71.646,
    y2: 28.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.269 30.72h-9.671a1.751 1.751 0 01-1.752-1.752v0c0-.968.784-1.752 1.752-1.752h9.671c.968 0 1.752.784 1.752 1.752v0c0 .968-.784 1.752-1.752 1.752z",
    fill: "none",
    stroke: "url(#SVGID_1_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: 43.455,
    y1: 34.192,
    x2: 50.807,
    y2: 34.192,
    gradientTransform: "translate(0 .968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M44.08 35.159h6.102"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: 52.793,
    y1: 34.192,
    x2: 60.667,
    y2: 34.192,
    gradientTransform: "translate(0 .968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.418 35.159h6.624"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: 62.654,
    y1: 34.192,
    x2: 71.646,
    y2: 34.192,
    gradientTransform: "translate(0 .968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.279 35.159h7.742"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: 43.455,
    y1: 37.788,
    x2: 56.908,
    y2: 37.788,
    gradientTransform: "translate(0 .968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M44.08 38.756h12.203"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: 58.895,
    y1: 37.788,
    x2: 71.646,
    y2: 37.788,
    gradientTransform: "translate(0 .968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M59.52 38.756h11.501"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16226.188,
    y1: -279.463,
    x2: -16207.335,
    y2: -279.463,
    gradientTransform: "matrix(1 0 0 -1 16269.643 -237.111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M44.08 42.352h17.603"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16235.526,
    y1: -279.463,
    x2: -16228.175,
    y2: -279.463,
    gradientTransform: "matrix(1 0 0 -1 16299.82 -237.111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M64.919 42.352h6.102"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16271.305,
    y1: 17.957,
    x2: -16256.88,
    y2: 17.957,
    gradientTransform: "matrix(-1 0 0 1 -16243.526 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.731 19.709h9.671c.968 0 1.752-.784 1.752-1.752v0c0-.968-.784-1.752-1.752-1.752h-9.671c-.968 0-1.752.784-1.752 1.752v0c0 .968.784 1.752 1.752 1.752z",
    fill: "none",
    stroke: "url(#SVGID_9_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16265.872,
    y1: -719.449,
    x2: -16256.88,
    y2: -719.449,
    gradientTransform: "rotate(180 -8121.763 -344.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21.721 31.34h-7.742"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16283.042,
    y1: -715.853,
    x2: -16275.424,
    y2: -715.853,
    gradientTransform: "rotate(180 -8121.763 -344.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M38.891 27.744h-6.368"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16273.436,
    y1: -715.853,
    x2: -16256.88,
    y2: -715.853,
    gradientTransform: "rotate(180 -8121.763 -344.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.286 27.744H13.979"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16265.313,
    y1: -712.257,
    x2: -16256.88,
    y2: -712.257,
    gradientTransform: "rotate(180 -8121.763 -344.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M21.162 24.148h-7.183"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c",
    gradientUnits: "userSpaceOnUse",
    x1: -16284.797,
    y1: -712.257,
    x2: -16267.3,
    y2: -712.257,
    gradientTransform: "rotate(180 -8121.763 -344.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_14_330ede60183fe86cfea559e7e74ca50b7404f11d772b70f57563610b9b05800c)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M40.646 24.148H24.399"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M46.212 22.314v-4.412a6.6 6.6 0 00-6.6-6.6H15.377a6.6 6.6 0 00-6.6 6.6v12.389a6.6 6.6 0 006.6 6.6h3.364l-2.145 5.094 9.384-5.094h12.808"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M45.387 22.314h24.236a6.6 6.6 0 016.6 6.6v12.389a6.6 6.6 0 01-6.6 6.6h-3.364l2.145 5.094-9.384-5.094H45.387a6.6 6.6 0 01-6.6-6.6V28.914a6.601 6.601 0 016.6-6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.68bc8aa4a024c2cf690a2da4a3c77c2f.svg";
export { ForwardRef as ReactComponent };